var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 768,
    height: 540,
    viewBox: "0 0 768 540",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_46_12628",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -228,
    width: 768,
    height: 768
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 768,
    height: 768,
    transform: "translate(0 -228)",
    fill: "url(#paint0_radial_46_12628)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_46_12628)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_12628)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_46_12628)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -228,
    x2: 0.5,
    y2: 540,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.5,
    y1: -228,
    x2: 48.5,
    y2: 540,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.5,
    y1: -228,
    x2: 96.5,
    y2: 540,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.5,
    y1: -228,
    x2: 144.5,
    y2: 540,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.5,
    y1: -228,
    x2: 192.5,
    y2: 540,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.5,
    y1: -228,
    x2: 240.5,
    y2: 540,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.5,
    y1: -228,
    x2: 288.5,
    y2: 540,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 336.5,
    y1: -228,
    x2: 336.5,
    y2: 540,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.5,
    y1: -228,
    x2: 384.5,
    y2: 540,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 432.5,
    y1: -228,
    x2: 432.5,
    y2: 540,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.5,
    y1: -228,
    x2: 480.5,
    y2: 540,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 528.5,
    y1: -228,
    x2: 528.5,
    y2: 540,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 576.5,
    y1: -228,
    x2: 576.5,
    y2: 540,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 624.5,
    y1: -228,
    x2: 624.5,
    y2: 540,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 672.5,
    y1: -228,
    x2: 672.5,
    y2: 540,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720.5,
    y1: -228,
    x2: 720.5,
    y2: 540,
    stroke: "#EAECF0"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -227.5,
    width: 767,
    height: 767,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_46_12628)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: 11.5,
    x2: 768,
    y2: 11.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 59.5,
    x2: 768,
    y2: 59.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 107.5,
    x2: 768,
    y2: 107.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 155.5,
    x2: 768,
    y2: 155.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 203.5,
    x2: 768,
    y2: 203.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 251.5,
    x2: 768,
    y2: 251.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 299.5,
    x2: 768,
    y2: 299.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 347.5,
    x2: 768,
    y2: 347.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 395.5,
    x2: 768,
    y2: 395.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 443.5,
    x2: 768,
    y2: 443.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 491.5,
    x2: 768,
    y2: 491.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 539.5,
    x2: 768,
    y2: 539.5,
    stroke: "#EAECF0"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -227.5,
    width: 767,
    height: 767,
    stroke: "#EAECF0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_46_12628",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(384 384) rotate(90) scale(384 384)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_12628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 768,
    height: 768,
    fill: "white",
    transform: "translate(0 -228)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_46_12628"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -228,
    width: 768,
    height: 768,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_46_12628"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -228,
    width: 768,
    height: 768,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthBackground);
export default __webpack_public_path__ + "static/media/authBackground.986965595998d548330a0a2e7ba01c47.svg";
export { ForwardRef as ReactComponent };